import { GetAISummarizeParamsProps } from '@/pages/aigc/service';
export const formattingFormData = (data: GetAISummarizeParamsProps): string => {
  let ret = '';
  for (const it in data) {
    // 如果 data[it] 是一个对象, 需要先使用 JSON.stringify, 再使用 encode
    ret += `${encodeURIComponent(it)}=${encodeURIComponent(data[it])}&`;
  }
  ret = ret.substring(0, ret.lastIndexOf('&'));
  return ret;
};